<template>
    <main class="main">
        <div class="container">
            <slot name="header" />

            <div class="row">
                <!-- Filter column -->
                <div class="col-lg-3 d-flex flex-column">
                    <slot name="before-filters" />

                    <the-filters
                        :filters="filters"
                        :module-name="moduleName"
                        :show-user-filters="showUserFilters"
                        @applyFilters="$emit('apply-filters', $event)"
                    />

                    <slot name="after-filters" />
                </div>
                <!-- /Filter column -->

                <!-- Main content column -->
                <div class="col-lg-9">
                    <slot name="content" />
                </div>
            </div>
        </div>

        <slot name="selected-bar" />
    </main>
</template>

<script>
export default {
    props: {
        filters: {
            type: Object,
            required: true
        },
        moduleName: {
            type: String,
            required: true
        },
        showUserFilters: {
            type: Boolean,
            default: false
        }
    }
}
</script>
